<script>
export default {
  name: 'NoticeView',
  props: {
    notice: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    getDateText (value) {
      if (!value) return '-'
      return String(value).replace('T', ' ').substring(0, 16)
    }
  }
}
</script>

<template>
  <div id="notice_view">
    <div class="common_view_tit">{{ notice.subject || '-' }}</div>
    <div class="common_view_head notice_view_head">
      <div>작성자</div>
      <div>{{ notice.userId || notice.regUserId || '-' }}</div>
      <div>작성일</div>
      <div>{{ getDateText(notice.updDate || notice.regDate) }}</div>
    </div>
    <div class="notice_view_content toastui-editor-contents" v-html="notice.content || ''"></div>
  </div>
</template>

<style scoped>
#notice_view {
  width: 100%;
}

.notice_view_head {
  border-top: 1px solid #E2E8ED;
  border-bottom: 1px solid #E2E8ED;
  margin-top: 0;
}

.notice_view_head > div:nth-child(odd) {
  width: 90px;
  flex-shrink: 0;
  background: #F8F8F8;
  text-align: center;
}

.notice_view_head > div:nth-child(even) {
  flex: 1;
  padding-left: 20px;
  text-align: left;
}

.notice_view_content {
  overflow-y: auto;
  max-height: 460px;
  padding: 24px 30px;
  box-sizing: border-box;
  color: #36414F;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  word-break: break-all;
}

.notice_view_content /deep/ img {
  max-width: 100%;
}

.notice_view_content /deep/ p {
  margin: 0 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeView.vue